import { data } from '../../svg/CalendarClock/data';
import { makeIcon } from '../makeIcon';

export const CalendarClock = makeIcon(data, 'calendar_clock', 'CalendarClock');

export default CalendarClock;
